export default "__VITE_ASSET__DpMbxKXd__"